module.exports = __webpack_public_path__ + "static/media/new-york-life-logo.5ce008a1.jpeg";